module.exports = __webpack_public_path__ + "images/backgrounds/dew/small.71633df28ad4038a6fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/dew/small.jpg
// module id = 9yLf
// module chunks = 12